import React from 'react'
import { Icon, IconProps } from '../components/Icon'
const SvgFooterGooglePlay: React.FC<IconProps> = (props) => {
  return (
    <Icon viewBox="0 0 135 40" xmlns="http://www.w3.org/2000/svg" {...props}>
      <linearGradient
        id="footer-google-play_svg__a"
        gradientTransform="matrix(1 0 0 -1 0 182)"
        gradientUnits="userSpaceOnUse"
        x1={21.8}
        x2={5.017}
        y1={173.29}
        y2={156.508}
      >
        <stop offset={0} stopColor="#00a0ff" />
        <stop offset={0.007} stopColor="#00a1ff" />
        <stop offset={0.26} stopColor="#00beff" />
        <stop offset={0.512} stopColor="#00d2ff" />
        <stop offset={0.76} stopColor="#00dfff" />
        <stop offset={1} stopColor="#00e3ff" />
      </linearGradient>
      <linearGradient
        id="footer-google-play_svg__b"
        gradientTransform="matrix(1 0 0 -1 0 182)"
        gradientUnits="userSpaceOnUse"
        x1={33.834}
        x2={9.637}
        y1={161.999}
        y2={161.999}
      >
        <stop offset={0} stopColor="#ffe000" />
        <stop offset={0.409} stopColor="#ffbd00" />
        <stop offset={0.775} stopColor="orange" />
        <stop offset={1} stopColor="#ff9c00" />
      </linearGradient>
      <linearGradient
        id="footer-google-play_svg__c"
        gradientTransform="matrix(1 0 0 -1 0 182)"
        gradientUnits="userSpaceOnUse"
        x1={24.827}
        x2={2.069}
        y1={159.704}
        y2={136.946}
      >
        <stop offset={0} stopColor="#ff3a44" />
        <stop offset={1} stopColor="#c31162" />
      </linearGradient>
      <linearGradient
        id="footer-google-play_svg__d"
        gradientTransform="matrix(1 0 0 -1 0 182)"
        gradientUnits="userSpaceOnUse"
        x1={7.297}
        x2={17.46}
        y1={181.824}
        y2={171.661}
      >
        <stop offset={0} stopColor="#32a071" />
        <stop offset={0.069} stopColor="#2da771" />
        <stop offset={0.476} stopColor="#15cf74" />
        <stop offset={0.801} stopColor="#06e775" />
        <stop offset={1} stopColor="#00f076" />
      </linearGradient>
      <path
        d="M130 40H5c-2.75 0-5-2.25-5-5V5c0-2.75 2.25-5 5-5h125c2.75 0 5 2.25 5 5v30c0 2.75-2.25 5-5 5z"
        fill="#6f727f"
      />
      <path
        d="M47.418 10.243c0 .838-.248 1.506-.745 2.003-.564.592-1.3.888-2.204.888-.868 0-1.604-.3-2.21-.9s-.91-1.346-.91-2.234c0-.89.304-1.633.91-2.233s1.34-.9 2.208-.9c.43 0 .84.083 1.23.25.39.168.705.39.94.67l-.528.53c-.398-.476-.945-.713-1.643-.713-.633 0-1.18.22-1.64.666-.46.444-.69 1.02-.69 1.73s.23 1.286.69 1.73c.46.445 1.007.667 1.64.667.67 0 1.228-.224 1.675-.67.29-.29.458-.696.503-1.216h-2.18v-.72h2.908c.03.158.042.31.042.454zm4.61-2.506h-2.733V9.64h2.464v.72h-2.466v1.903h2.733V13h-3.503V7h3.503v.737zM55.28 13h-.773V7.737H52.83V7h4.124v.737H55.28zm4.658 0V7h.77v6zm4.19 0h-.77V7.737H61.68V7h4.124v.737h-1.676zm9.482-.775c-.59.606-1.324.91-2.2.91-.878 0-1.61-.304-2.2-.91s-.884-1.348-.884-2.225.294-1.62.884-2.225c.59-.606 1.322-.91 2.2-.91.87 0 1.603.305 2.195.914.592.607.888 1.347.888 2.22 0 .876-.295 1.62-.884 2.224zm-3.83-.503c.444.45.987.675 1.63.675.642 0 1.186-.225 1.63-.675.443-.45.666-1.024.666-1.722s-.223-1.272-.667-1.722a2.207 2.207 0 00-1.63-.674c-.644 0-1.187.224-1.63.674-.445.45-.668 1.024-.668 1.722s.223 1.273.666 1.722zM75.575 13V7h.94l2.915 4.668h.033l-.033-1.157V7h.77v6h-.804l-3.05-4.894h-.034l.034 1.157V13h-.77z"
        fill="#fff"
        stroke="#fff"
        strokeMiterlimit={10}
        strokeWidth={0.2}
      />
      <path
        d="M68.136 21.752c-2.352 0-4.27 1.788-4.27 4.253 0 2.45 1.918 4.253 4.27 4.253s4.27-1.804 4.27-4.253c0-2.465-1.918-4.253-4.27-4.253zm0 6.83c-1.29 0-2.4-1.063-2.4-2.577 0-1.53 1.11-2.578 2.4-2.578s2.4 1.047 2.4 2.578c0 1.514-1.11 2.578-2.4 2.578zm-9.314-6.83c-2.352 0-4.27 1.788-4.27 4.253 0 2.45 1.918 4.253 4.27 4.253s4.27-1.804 4.27-4.253c0-2.465-1.917-4.253-4.27-4.253zm0 6.83c-1.29 0-2.4-1.063-2.4-2.577 0-1.53 1.112-2.578 2.4-2.578 1.29 0 2.4 1.047 2.4 2.578 0 1.514-1.11 2.578-2.4 2.578zm-11.078-5.525v1.804h4.317c-.127 1.017-.465 1.758-.98 2.274-.63.628-1.612 1.32-3.335 1.32-2.66 0-4.737-2.142-4.737-4.8s2.078-4.8 4.737-4.8c1.434 0 2.48.563 3.254 1.288l1.272-1.272c-1.08-1.03-2.512-1.82-4.526-1.82-3.64 0-6.702 2.964-6.702 6.605 0 3.64 3.06 6.605 6.702 6.605 1.965 0 3.447-.644 4.607-1.853 1.193-1.192 1.564-2.867 1.564-4.22 0-.42-.032-.806-.097-1.128h-6.073zm45.308 1.4c-.355-.95-1.434-2.705-3.64-2.705-2.192 0-4.013 1.724-4.013 4.253 0 2.384 1.803 4.253 4.22 4.253 1.95 0 3.076-1.192 3.544-1.885l-1.45-.967c-.484.71-1.144 1.177-2.095 1.177-.95 0-1.628-.435-2.063-1.29l5.687-2.35-.193-.485zm-5.8 1.42c-.048-1.644 1.273-2.482 2.223-2.482.742 0 1.37.37 1.58.902zM82.628 30h1.87V17.5h-1.87zm-3.06-7.298h-.065c-.42-.5-1.224-.95-2.24-.95-2.126 0-4.075 1.87-4.075 4.27 0 2.383 1.95 4.236 4.076 4.236 1.015 0 1.82-.45 2.24-.967h.063v.615c0 1.627-.87 2.497-2.27 2.497-1.145 0-1.854-.82-2.144-1.514l-1.627.677c.467 1.128 1.708 2.513 3.77 2.513 2.19 0 4.044-1.29 4.044-4.43V22.01h-1.773v.692zm-2.143 5.88c-1.29 0-2.368-1.08-2.368-2.56 0-1.5 1.08-2.595 2.368-2.595 1.273 0 2.27 1.096 2.27 2.594 0 1.484-.997 2.564-2.27 2.564zm24.38-11.083h-4.47V30H99.2v-4.736h2.606c2.068 0 4.1-1.497 4.1-3.883s-2.032-3.88-4.1-3.88zm.05 6.023H99.2V19.24h2.654c1.395 0 2.187 1.154 2.187 2.14 0 .97-.79 2.144-2.185 2.144zm11.53-1.795c-1.35 0-2.75.594-3.33 1.913l1.658.69c.354-.69 1.013-.915 1.705-.915.965 0 1.946.58 1.962 1.61v.127c-.338-.193-1.062-.482-1.946-.482-1.785 0-3.603.98-3.603 2.815 0 1.672 1.466 2.75 3.106 2.75 1.255 0 1.946-.563 2.38-1.223h.065v.965h1.8v-4.793c0-2.22-1.654-3.458-3.793-3.458zm-.225 6.85c-.61 0-1.463-.305-1.463-1.06 0-.966 1.06-1.336 1.978-1.336.82 0 1.206.177 1.705.418a2.262 2.262 0 01-2.22 1.978zM123.743 22l-2.14 5.42h-.063L119.32 22h-2.01l3.33 7.575-1.9 4.214h1.947l5.13-11.79h-2.074zm-16.807 8h1.866V17.5h-1.866z"
        fill="#fff"
      />
      <path
        d="M10.435 7.538c-.29.308-.463.786-.463 1.405V31.06c0 .62.173 1.096.463 1.404l.074.072 12.387-12.39v-.29l-12.39-12.39-.073.073z"
        fill="url(#footer-google-play_svg__a)"
      />
      <path
        d="M27.028 24.28l-4.13-4.133v-.29l4.13-4.13.094.052 4.893 2.78c1.397.793 1.397 2.092 0 2.886l-4.893 2.78-.094.054z"
        fill="url(#footer-google-play_svg__b)"
      />
      <path
        d="M27.122 24.225L22.898 20 10.435 32.465c.46.488 1.22.548 2.078.06l14.61-8.3"
        fill="url(#footer-google-play_svg__c)"
      />
      <path
        d="M27.122 15.777l-14.61-8.3c-.855-.487-1.616-.427-2.077.06L22.898 20l4.224-4.222z"
        fill="url(#footer-google-play_svg__d)"
      />
      <path
        d="M27.03 24.132L12.512 32.38c-.812.46-1.537.43-2.003.01l-.076.074.074.073c.466.42 1.19.45 2.003-.012l14.61-8.3-.093-.093z"
        opacity={0.2}
      />
      <path
        d="M10.435 32.318c-.29-.308-.463-.785-.463-1.405v.147c0 .62.173 1.097.463 1.404l.075-.074zM32.015 21.3l-4.985 2.83.092.093 4.893-2.78c.698-.397 1.048-.92 1.048-1.443-.06.473-.415.937-1.048 1.297z"
        opacity={0.12}
      />
      <path
        d="M12.513 7.623l19.502 11.08c.633.36.99.824 1.048 1.298 0-.52-.35-1.045-1.048-1.442L12.513 7.478c-1.397-.795-2.54-.135-2.54 1.465v.147c0-1.6 1.143-2.26 2.54-1.467z"
        fill="#fff"
        opacity={0.25}
      />
    </Icon>
  )
}
export default SvgFooterGooglePlay
